import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector, connect } from "react-redux";
import { Box } from "@mui/material";
import BuildLevel from "./BuildLevel";

import { getBuild as getPlanBuild } from "../../../redux-store/testPlanBuildReducers/testPlanBuildActions";
import { getBuild as getSuiteBuild } from "../../../redux-store/testSuiteBuildReducers/testSuiteBuildActions";
import { getBuild as getScenarioBuild } from "../../../redux-store/testScenarioBuildReducers/testScenarioBuildActions";
import { setBuilds as setPlanBuilds } from "../../../redux-store/testPlanBuildReducers/testPlanBuildSlice";
import { setBuilds as setSuiteBuilds } from "../../../redux-store/testSuiteBuildReducers/testSuiteBuildSlice";
import { setBuilds as setScenarioBuilds } from "../../../redux-store/testScenarioBuildReducers/testScenarioBuildSlice";

import { getProject } from '../../../redux-store/currentUserActions';
import { setSelectedProject } from 'reducers/commonSlice.js';

const levelMap = {
  testPlan: {
    id: "test_plan",
    type: "level",
    name: "Test Plan",
    childBuildKeys: ["test_suite_builds", "test_scenario_builds"],
    childBuildTypes: ["testSuite", "testScenario"],
    buildIdKey: "testPlanBuildId",
    sourceCodePrefix: "TP-0",
  },
  testSuite: {
    id: "test_suite",
    type: "level",
    name: "Test Suite",
    childBuildKey: "test_scenario_builds",
    childBuildType: "testScenario",
    buildIdKey: "testSuiteBuildId",
    sourceCodePrefix: "TSS-0",
  },
  testScenario: {
    id: "test_scenario",
    type: "level",
    name: "Test Scenario",
    childBuildKey: "test_case_builds",
    childBuildType: "testCase",
    childType: "log",
    buildIdKey: "testScenarioBuildId",
    sourceCodePrefix: "TS-0",
  },
};

const BuildContainer = ({ buildType = "testPlan", buildId, project }) => {
  const dispatch = useDispatch();

  const getBuild = async (buildType, buildId) => {
    const levelInfo = getLevelInfo(buildType);
    let buildDetail;
    if (buildType === "testPlan") {
      const planResponse = await dispatch(getPlanBuild({ testPlanBuildId: buildId }));
      if (planResponse?.payload?.project_id !== project.id) {
        await updateSelectedProjectInState(planResponse?.payload?.project_id);
      }
      buildDetail = planResponse?.payload;
      await dispatch(setPlanBuilds({ [buildDetail?.id]: { ...buildDetail } }));
      // Set both test_suite_builds and test_scenario_builds in Redux
      const suiteBuilds = buildDetail["test_suite_builds"] || [];
      for (let i = 0; i < suiteBuilds.length; i++) {
        await dispatch(setSuiteBuilds({ [suiteBuilds[i].id]: suiteBuilds[i] }));
      }

      const scenarioBuilds = buildDetail["test_scenario_builds"] || [];
      for (let i = 0; i < scenarioBuilds.length; i++) {
        await dispatch(setScenarioBuilds({ [scenarioBuilds[i].id]: scenarioBuilds[i] }));
      }
    } else if (buildType === "testSuite") {
      const suiteResponse = await dispatch(getSuiteBuild({ testSuiteBuildId: buildId }));
      if (suiteResponse?.payload?.project_id !== project.id) {
        await updateSelectedProjectInState(suiteResponse?.payload?.project_id);
      }
      buildDetail = suiteResponse?.payload;
      await dispatch(setSuiteBuilds({ [buildDetail?.id]: { ...buildDetail } }));
      const childBuilds = buildDetail["test_scenario_builds"] || [];
      for (let i = 0; i < childBuilds.length; i++)
        await dispatch(setScenarioBuilds({ [childBuilds[i].id]: childBuilds[i] }));
    } else if (buildType === "testScenario") {
      const scenarioResponse = await dispatch(getScenarioBuild({ testScenarioBuildId: buildId }));
      if (scenarioResponse?.payload?.project_id !== project.id) {
        await updateSelectedProjectInState(scenarioResponse?.payload?.project_id);
      }
      buildDetail = scenarioResponse?.payload;
      await dispatch(setScenarioBuilds({ [buildDetail?.id]: { ...buildDetail } }));
    }
  };


  const updateSelectedProjectInState = async (projectId) => {
    if(!projectId) return;
    const response = await dispatch(getProject({ projectId: projectId }));
    await dispatch(setSelectedProject(response.payload));
    localStorage.setItem('lastSelectedProject', JSON.stringify(response.payload));
  }

  const getLoadingState = (buildType, buildId) => {

  }

  const getLevelInfo = useCallback((levelType) => {
    return levelMap[levelType];
  }, []);

  return (
    <Box sx={{ height: "calc(100vh - 50px)", pb: 20 }}>
      <BuildLevel
        buildType={buildType}
        getBuild={getBuild}
        buildId={buildId}
        getLevelInfo={getLevelInfo}
        getLoadingState={getLoadingState}
        expanded={true}
        root={true}
      />
    </Box>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    project: state.common.selectedProject,
  };
};

export default connect(mapStateToProps)(BuildContainer);